export function Wordmark({ className = "", accentClassName = "text-blue-400" }) {
  return (
    <span className={className} data-testid="app-wordmark">
      Modern<span className={accentClassName}>Tect</span>
    </span>
  );
}
